const Mock = require('mockjs')

let datanew = Mock.mock({
    list: [
        {
            id: 1,
            title: '槽车(桶车)装卸货整体流程指引',
            describe: '槽车(桶车)装卸货整体流程指引，包括装卸地点、装卸时间、资料备案、账号注册等',
            date: '2023-12-09',
            author: '管理员',
            type: ["q1", "账号备案"],
            content: 'https://images.nshdcc.com/nshd/md/t11.md',
            click: 60,
            img: 'https://images.nshdcc.com/nshd/bt/t1.png'
        },
        {
            id: 2,
            title: '小虎管理中心司机、车辆备案方案',
            describe: '运输单位拨打小虎咨询电话020-84976756，提交资料，由小虎管理中心提供账号和初始密码。并按如下指引完成资料备案',
            date: '2023-12-09',
            author: '管理员',
            type: ["q1", "账号备案"],
            content: 'https://images.nshdcc.com/nshd/md/t12.md',
            click: 60,
            img: 'https://images.nshdcc.com/nshd/bt/t2.png'
        },
        {
            id: 3,
            title: '约车系统司机账号注册',
            describe: '在我司公众号预约系统登录页面点击下发的新用户注册连接，按照提示输入必要的信息。除了挂车号，其他都是必填项目。输入所有信息后点击注册按钮完成注册',
            date: '2023-12-09',
            author: '管理员',
            type: ["q1", "账号备案"],
            content: 'https://images.nshdcc.com/nshd/md/t13.md',
            click: 60,
            img: 'https://images.nshdcc.com/nshd/bt/t3.png'
        },
        {
            id: 4,
            title: '司机、车辆资料录入库区系统',
            describe: '车辆首次入库作业(或资料有效期等信息发生变化时)，司机需配合我司门岗工作人员，将上述资料录入系统',
            date: '2023-12-09',
            author: '管理员',
            type: ["q1", "账号备案"],
            content: 'https://images.nshdcc.com/nshd/md/t14.md',
            click: 60,
            img: 'https://images.nshdcc.com/nshd/bt/t4.png'
        },
        {
            id: 9,
            title: '车辆预约作业及电子运单说明',
            describe: '选择本次需要预约的槽车出库单据，点击预约按钮进入预约界面。预约有槽车出库，槽车入库，桶进库，桶出库一共四种类型。',
            date: '2023-12-09',
            author: '管理员',
            type: ["q2", "装卸作业"],
            content: 'https://images.nshdcc.com/nshd/md/t15.md',
            click: 60,
            img: 'https://images.nshdcc.com/nshd/bt/t5.png'
        }
        ,
        {
            id: 10,
            title: '车辆安检说明',
            describe: '我司共有三个槽车作业区，分别为：化工区、沥青区和油品区，停车场只有油品停车场和化工停车场两个，司机预约后请注意系统分配的作业区及鹤管位，化工区、沥青区的车辆在化工停车场安检，油品区的车辆在油品停车场安检。',
            date: '2023-12-09',
            author: '管理员',
            type: ["q2", "装卸作业"],
            content: 'https://images.nshdcc.com/nshd/md/t17.md',
            click: 60,
            img: 'https://images.nshdcc.com/nshd/bt/t6.png'
        },
        {
            id: 11,
            title: 'ATM操作手册',
            describe: 'ATM自助提货系统功能包括桶装卸油、汽车装卸油、出库单等。',
            date: '2023-12-09',
            author: '管理员',
            type: ["q2", "装卸作业"],
            content: 'https://images.nshdcc.com/nshd/md/t18.md',
            click: 60,
            img: 'https://images.nshdcc.com/nshd/bt/t7.png'
        },
        {
            id: 12,
            title: '装卸车作业',
            describe: '司机停好车后，先到门岗检查证件和电子运单，门岗工作人员根据手持终端安全检查要求对槽车进行逐项检查，检查通过后，司机方可进行下一步作业，否则需要整改合格后才能作业。',
            date: '2023-12-09',
            author: '管理员',
            type: ["q2", "装卸作业"],
            content: 'https://images.nshdcc.com/nshd/md/t19.md',
            click: 60,
            img: 'https://images.nshdcc.com/nshd/bt/t8.png'
        },
        {
            id: 13,
            title: '手机预约常见问题',
            describe: '本文列举司机手机预约常见问题，如您遇到问题不在此列，可按我司联系方式直接联系相关人员咨询！',
            date: '2023-12-09',
            author: '管理员',
            type: ["q3", "常见问题"],
            content: 'https://images.nshdcc.com/nshd/md/t23.md',
            click: 60,
            img: 'https://images.nshdcc.com/nshd/bt/21.jpg'
        }
        ,
        {
            id: 14,
            title: 'ATM常见问题',
            describe: '本文列举ATM系统常见问题，如您遇到问题不在此列，可按我司联系方式直接联系相关人员咨询！',
            date: '2023-12-09',
            author: '管理员',
            type:  ["q3", "常见问题"],
            content: 'https://images.nshdcc.com/nshd/md/t21.md',
            click: 60,
            img: 'https://images.nshdcc.com/nshd/bt/20.jpg'
        }
        ,
        {
            id: 16,
            title: '“大港大船”新篇章',
            describe: '2023 年 11 月 14 日下午，中石化中海船舶燃料供油有限公司（以下简称“中石化中海”）和华南中石油国际事业有限公司（以下简称“华南中国石油”）进口保税低硫燃料油 3.8 万吨，经外轮 NEWAward（凯德轮）卸进南沙弘达油库',
            date: '2023-11-15',
            author: '管理员',
            type:  ["q4", "公司动态"],
            content: 'https://images.nshdcc.com/nshd/md/t16.md',
            click: 60,
            img: 'https://cdnjson.com/images/2023/12/15/11_.jpg'
        }
    ]
});



// const data = Mock.mock({
//     'list|500': [{
//         'id|+1': 1,
//         "title": '@ctitle(12, 25)',
//         'describe': '@ctitle(50, 80)',
//         'date': '@date(\'yyyy-MM-dd\')',
//         "author": Random.cname(), // "程强"
//         "type|1": {
//             "q1": "账号备案",
//             "q2": "装卸作业",
//             "q3": "常见问题",
//             "q4": "公司动态",
//             "q5": "行业新闻",
//             "q6": "安全资讯"
//         },
//         "content": '@csentence(500, 800)',
//         "click|1-500": 1,
//         "img": Random.image('394x224', '#16d46b', '#fff', 'png', 'Hello'),
//     }]
// })

Mock.mock('http://localhost:8080/helpListData', 'post', (option) => {

    const { currentPage, pageSize, type } = JSON.parse(option.body)
    const start = (currentPage - 1) * pageSize
    const end = currentPage * pageSize

    // let fe = datanew.list.filter(item => Object.prototype.hasOwnProperty.call(item.type, type))
    let fe = datanew.list.filter(item => item.type[0] == type)

    const list = fe.slice(start, end)

    return {
        code: 200,
        message: '查询成功',
        data: {
            list,
            currentPage,
            pageSize,
            totalElements: fe.length
        }
    }
})

Mock.mock('http://localhost:8080/searchList', 'post', (option) => {

    const { keyword } = JSON.parse(option.body)
    const list = datanew.list.filter(article => article.title.includes(keyword));
    return {
        code: 200,
        message: '查询成功',
        data: {
            list
        }
    }
})

Mock.mock('http://localhost:8080/searchListTop5', 'post', (option) => {

    const { keyword } = JSON.parse(option.body)
    let fe = datanew.list.filter(article => article.title.includes(keyword));
    const list = fe.slice(0, 5);
    return {
        code: 200,
        message: '查询成功',
        data: {
            list
        }
    }
})

Mock.mock('http://localhost:8080/indexTop5', 'post', (option) => {

    const { currentPage, pageSize } = JSON.parse(option.body)
    const start = (currentPage - 1) * pageSize
    const end = currentPage * pageSize



    let fe = datanew.list

    const list = datanew.list.slice(start, end)

    return {
        code: 200,
        message: '查询成功',
        data: {
            list,
            currentPage,
            pageSize,
            totalElements: fe.length
        }
    }
})


// 详情页数据
Mock.mock(`http://localhost:8080/detail`, 'post', option => {
    let id = JSON.parse(option.body)
    let detail = datanew.list.filter(item => item.id == id)
    // 详情页数据
    return {
        ...detail
    }
})